module.exports = __webpack_public_path__ + "static/media/mobile_shops_2x.dc8d4d1b.png";